import React from "react";

import { NumberInput } from "@common/numberInput";
import { AllocationUnit } from "@common/allocationUnit";
import { Props } from "./types";
import styles from "./styles.scss";

// Same field as the allocated hours and the completion, disabled: the spent
// time comes from the timesheets and cannot be edited here.
function SpentHours({ spentHours }: Props) {
  return (
    <div className={styles.spentHours}>
      <NumberInput
        className={styles.input}
        value={Math.round(spentHours * 100) / 100}
        input={() => {}}
        isDisabled
      />
      <p className={styles.text}>
        <AllocationUnit />
      </p>
    </div>
  );
}

export { SpentHours };
